export default {
    add: {
        ar: 'إضافة',
        en: 'add',
        es: 'agregar',
    },
    edit: {
        ar: 'تعديل',
        en: 'edit',
        es: 'editar',
    },
    save: {
        ar: 'حفظ',
        en: 'save',
        es: 'ahorrar',
    },
    cancel: {
        ar: 'إلغاء',
        en: 'cancel',
        es: 'cancelar',
    },
    search: {
        ar: 'بحث',
        en: 'Search',
        es: 'Buscar',
    },

    exports: {
        ar: {
            export: 'تصدير',
            'export-as-pdf': 'تصدير كـ pdf',
            'export-as-excel': 'تصدير كـ Excel',
        },
        en: {
            export: 'Export',
            'export-as-pdf': 'Export as pdf',
            'export-as-excel': 'Export as excel',
        },
        es: {
            export: 'Exportar',
            'export-as-pdf': 'Export as pdf',
            'export-as-excel': 'Export as excel',
        },
    },

    inputs: {
        ar: {
            name: 'الاسم',
            'fiscal-year': 'السنة المالية',
            'show-archived': 'عرض المؤرشفة',
            'company-name': 'اسم الشركة',
            'financial-file-start': 'تاريخ بداية الملف المالي',
            'financial-file-end': 'تاريخ نهاية الملف المالي',
            'currency': 'العملة',
            'default-language': 'اللغة الافتراضية',
            permission: 'الصلاحية',
            'refunded-from-invoice': 'مرتجع من فاتورة',
            date: 'التاريخ',
            'ref-doc': 'المستند',
            notes: 'ملاحظات',
            account: 'الحساب',
            warehouse: 'المستودع',
            'undefined': 'غير مُحدد',
            'purchasing-refund-account': 'حساب مرتجع المشتريات',
            'sales-refund-account': 'حساب مرتجع المبيعات',        
            type: 'النوع',
            material: 'المادة',
            'from-date': 'من تاريخ',
            'to-date': 'إلى تاريخ',
            'barcode': 'باركود',
            'region-name': 'اسم المنطقة',
            class: 'الصف',
            column: 'العمود'
        },
        en: {
            name: 'Name',
            'fiscal-year': 'Fiscal year',
            'show-archived': 'Show archived',
            'company-name': 'Company name',
            'financial-file-start': 'Financial file start date',
            'financial-file-end': 'Financial file end date',
            'currency': 'Default language',
            'default-language': 'Name',
            permission: 'Permission',
            'refunded-from-invoice': 'Refunded from invoice',
            date: 'Date',
            'ref-doc': 'Ref. Doc.',
            notes: 'notes',
            account: 'Account',
            warehouse: 'Warehouse',
            'undefined': 'Undefined',
            'purchasing-refund-account': 'Purchases refund account',
            'sales-refund-account': 'Sales refund account',
            type: 'Type',
            material: 'Item',
            'from-date': 'From date',
            'to-date': 'To date',
            'barcode': 'Barcode',
            'region-name': 'Region name',
            class: 'Class',
            column: 'Column'
        },
        es: {
            name: 'Nombre',
            'fiscal-year': 'Año fisical',
            'show-archived': 'Mostrar archivado',
            'company-name': 'Nombre de empresa',
            'financial-file-start': 'Fecha de inicio de archivo financiero',
            'financial-file-end': 'Fecha de finalización de archivo financiero',
            'currency': 'Idioma por defecto',
            'default-language': 'Moneda',
            permission: 'Permiso',
            'refunded-from-invoice': 'Devuelto de factura',
            date: 'Fecha',
            'ref-doc': 'Ref. Doc.',
            notes: 'Notas',
            account: 'Cuenta',
            warehouse: 'Almacén',
            'undefined': 'Indefinido',
            'purchasing-refund-account': 'Cuenta de reembolso de compra',
            'sales-refund-account': 'Cuenta de reembolso de venta',
            type: 'Tipo',
            material: 'Artículo',
            'from-date': 'De fecha',
            'to-date': 'Hasta fecha',
            'barcode': 'Código de barras',
            'region-name': '',
            class: '',
            column: ''
        },
    },

    buttons: {
        ar: {
            'change-state': 'تغيير الحالة',
            add: 'إضافة',
            create: 'إنشاء',
            new: 'جديد',
            'add-child': 'إضافة حساب فرعي',
            'account-statement': 'كشف حساب',
            edit: 'تعديل',
            delete: 'حذف',
            show: 'عرض',
            save: 'حفظ', 
            cancel: 'إلغاء', 
            browse: 'استعراض',
            previous: 'السابق',
            next: 'التالي',
            manage: 'إدارة',
            ok: 'موافق',
            search: 'بحث',
            back: 'رجوع'
        },

        en: {
            'change-state': 'Change status',
            add: 'Add',
            create: 'Create',
            new: 'New',
            'add-child': 'Add sub account',
            'account-statement': 'Account statement',
            edit: 'Edit',
            delete: 'Delete',
            show: 'Show',
            save: 'Save', 
            cancel: 'Cancel', 
            browse: 'Browse',
            previous: 'Previous',
            next: 'Next',
            manage: 'Manage',
            ok: 'OK',
            search: 'Search',
            back: 'Back'
        },

        es: {
            'change-state': 'Cambiar estado',
            add: 'Añadir',
            create: 'Crear',
            new: 'Nuevo',
            'add-child': 'Agregar subcuenta',
            'account-statement': 'Estado de cuenta',
            edit: 'Editar',
            delete: 'Eliminar',
            show: 'Mostrar',
            save: 'Guardar',
            cancel: 'Cancelar',
            browse: 'Navegar',
            previous: 'Anterior',
            next: 'Próximo',
            manage: 'Gestionar',
            ok: 'De acuerdo',
            search: 'Buscar',
            back: ''
        },
    },

    headers: {
        ar: {
            'company-name': 'اسم الشركة',
            'fiscal-year': 'السنة المالية',
            'start-date-of-the-file': 'تاريخ بداية الملف',
            'end-date-of-the-file': 'تاريخ نهاية الملف',
            currency: 'العملة',
            state: 'الحالة',
            actions: 'الأحداث',
            no: 'الرقم',
            warehouse: 'المستودع',
            material: 'المادة',
            quantity: 'الكمية',
            count: 'العدد',
            price: 'السعر',
            notes: 'ملاحظات',
            'net-amount': 'صافي القيمة',
            type: 'النوع',
            total: 'الإجمالي',
            account: 'الحساب',
            'ref-doc': 'المستند',
            date: 'التاريخ',
            "source-warehouse": 'المستودع المصدر',
            "target-warehouse": 'المستودع الهدف',
            'paper-document-no': 'المستند الورقي',
            'amount': 'القيمة',
            'region-name': 'اسم المنطقة',
            class: 'الصف',
            column: 'العمود',
            balance: 'الرصيد',
            debit: 'مدين',
            credit: 'دائن',
            note: 'البيان'
        },
        en: {
            'company-name': 'Company name',
            'fiscal-year': 'Fiscal year',
            'start-date-of-the-file': 'Financial file start date',
            'end-date-of-the-file': 'Financial file end date',
            currency: 'Currency',
            state: 'Status',
            actions: 'Actions',
            no: 'Serial',
            warehouse: 'Warehouse',
            material: 'Item',
            quantity: 'Quantity',
            count: 'Count',
            price: 'Price',
            notes: 'notes',
            'net-amount': 'Net amount',
            type: 'Type',
            total: 'Total',
            account: 'Account',
            'ref-doc': 'Ref. Doc.',
            date: 'Date',
            "source-warehouse": "Source warehouse",
            "target-warehouse": "Target warehouse",
            'paper-document-no': 'Paper document no',
            'amount': 'Amount',
            'region-name': 'Region name',
            class: 'Class',
            column: 'Column',
            balance: 'Balance',
            debit: 'Debit',
            credit: 'Credit',
            note: 'Note'
        },
        es: {
            'company-name': 'Nombre de empresa',
            'fiscal-year': 'Año fisical',
            'start-date-of-the-file': 'Fecha de inicio de archivo financiero',
            'end-date-of-the-file': 'Fecha de finalización de archivo financiero',
            currency: 'Moneda',
            state: 'Estado',
            actions: 'Acciones',
            no: 'Número',
            warehouse: 'Almacén',
            material: 'Artículo',
            quantity: 'Cantidad',
            count: 'Conteo',
            price: 'Precio',
            notes: 'Notas',
            'net-amount': 'Valor neto',
            type: 'Tipo',
            total: 'Total',
            account: 'Cuenta',
            'ref-doc': 'Ref. Doc.',
            date: 'Fetch',
            "source-warehouse": 'Almacén de origen',
            "target-warehouse": 'Almacén objetivo',
            "paper-document-no": "",
            "amount": "",
            'region-name': "",
            class: '',
            column: '',
            balance: 'Balance',
            debit: 'Débito',
            credit: 'crédito',
            note: 'nota'
        },
    },

    tooltip: {
        ar: {
            cached: 'تحديث سعر العملة',
            history: 'عرض سجل تحديثات العملة',
            statement: 'كشف',
            folder: 'عرض ملفات المُستخدم',
            'preview-file': 'استعراض محتويات الملف',
            inventory: 'جرد مواد المستودع' ,
            upload: 'إرفاق لوغو',
            archive: 'أرشفة',
            unarchive: 'إلغاء الأرشفة',
            'change-state': 'تغيير الحالة',
            edit: 'تعديل',
            delete: 'حذف',
        },
        en: {
            cached: 'Update exchange rate',
            history: 'Exchange rate history',
            statement: 'Statement',
            folder: 'Show user files',
            'preview-file': 'Preview file',
            inventory: 'Warehouse items inventory',
            upload: 'Attach logo',
            archive: 'Archive',
            unarchive: 'Unarchive',
            'change-state': 'Change status',
            edit: 'Edit',
            delete: 'Delete',
        },
        es: {
            cached: 'Actualizar tipo de cambio',
            history: 'Mostrar historial de tipos de cambio',
            statement: 'Estado',
            folder: 'Mostrar archivos de usuario',
            'preview-file': 'Vista previa del archivo',
            inventory: 'Inventario de artículos de almacén',
            upload: 'Adjuntar logo',
            archive: 'Archivo',
            unarchive: 'Desarchivar',
            'change-state': 'Cambiar estado',
            edit: 'Editar',
            delete: 'Eliminar',
        }
    },

    components: {
        ar: {
            'shown-rows': 'الأسطر المعروضة'
        },
        en: {
            'shown-rows': 'Shown rows'
        },
        es: {
            'shown-rows': 'Filas mostradas'
        },
    },

    invoices: {
        ar: {
            'available-next-version': 'سيتم إتاحة الميزة في إصدار لاحق',
            'add-invoice': 'إضافة فاتورة',
            'delete-invoice': 'حذف فاتورة',
            'delete-invoice-confirm': 'هل أنت متأكد من حذف الفاتورة سيتم حذف السند المُرتبط أيضاً؟',
            'invoice-no': 'رقم الفاتورة',
            'net-invoice': 'صافي الفاتورة',
            posted: 'مُرحّل',
            'non-posted': 'غير مُرحّل',
            total: 'الإجمالي',
            'delete-entry': 'حذف قيد',
            'are-you-sure-you-want-to-delete-the-entry': 'هل أنت متأكد من حذف القيد؟',
        },
        en: {
            'available-next-version': 'The feature will be available in a later version',
            'add-invoice': 'Add invoice',
            'delete-invoice': 'Delete invoice',
            'delete-invoice-confirm': 'Do you want to  delete this invoice? the related bond will also be deleted?',
            'invoice-no': 'Invoice no',
            'net-invoice': 'Grand Amount',
            posted: 'Posted',
            'non-posted': 'Non-posted',
            total: 'Total',
            'delete-entry': 'Delete entry',
            'are-you-sure-you-want-to-delete-the-entry': 'Are you sure you want to delete the entry?',
        },
        es: {
            'available-next-version': 'La característica estará disponible en una versión posterior',
            'delete-invoice': 'Eliminar factura',
            'add-invoice': 'Añadir factura',
            'delete-invoice-confirm': '¿Está seguro de eliminar la factura, el bono asociado también se eliminará?',
            'invoice-no': 'Número de factura',
            'net-invoice': 'Gran cantidad',
            posted: 'Publicado',
            'non-posted': 'No-publicado',
            total: 'total',
            'delete-entry': 'Eliminar la entrada',
            'are-you-sure-you-want-to-delete-the-entry': '¿Está seguro de que desea eliminar la entrada?',
        }
    },

    'table-messages': {
        ar: {
            'debit-and-credit-required': 'يجب إدخال إحدى حقول المدين / الدائن',
            'debit-and-credit-one-of': 'لا يمكن إدخال مدين ودائن ضمن قيد واحد',
            'account-required': 'يجب إدخال اسم الحساب',
            'date-required': 'يجب إدخال تاريخ القيد',
            'no-currency-debit-and-credit-without-currency': 'لا يجب إدخال حقول عملة مدينة / عملة دائنة بدون تحديد العملة',
            'currency-debit-and-credit-required': 'يجب إدخال إحدى حقول عملة مدينة / عملة دائنة',
            'currency-debit-and-credit-one-of': 'لا يمكن إدخال عملة دائنة وعملة مدينة ضمن قيد واحد',
            'debit-with-currency-debit-relation': 'يشترط توافق ملء كلا من مدين مع عملة مدينة',
            'credit-with-currency-credit-relation': 'يشترط توافق ملء كلا من دائن مع عملة دائنة',
            'currency-required': 'يجب اختيار نوع العملة ثم ضبط السعر',
            'currency-price-required': 'يجب إدخال سعر العملة',

            'material-required': 'يجب إدخال حقل المادة',
            'quantity-required': 'يجب إدخال حقل الكمية',
            'price-required': 'يجب إدخال حقل السعر',
        },
        en: {
            'debit-and-credit-required': 'One of the debit / credit fields must be entered',
            'debit-and-credit-one-of': 'Debit and credit can\'t be entered in one entry',
            'account-required': 'Account must be entered',
            'date-required': 'Entry date must be entered',
            'no-currency-debit-and-credit-without-currency': 'Currency must be entered before the foreign currency credit / debit',
            'currency-debit-and-credit-required': 'One of the foreign currency credit / debit must be entered',
            'currency-debit-and-credit-one-of': 'Foreign currency debit and foreign currency credit can\'t be entered in the same entry',
            'debit-with-currency-debit-relation': 'Specify Foreign currency debit for debit (incompatible inputs)',
            'credit-with-currency-credit-relation': 'Specify foreign currency credit for credit (incompatible inputs)',
            'currency-required': 'Choose currency before',
            'currency-price-required': 'Currency price must be entered',
            
            'quantity-required': 'Quantity is required',
            'price-required': 'Price is required',
            'material-required': 'Item is required ',
        },
        es: {
            'debit-and-credit-required': 'Se debe ingresar uno de los campos de débito/crédito',
            'debit-and-credit-one-of': 'El débito y el crédito no se pueden ingresar en un solo asiento',
            'account-required': 'Se debe ingresar la cuenta',
            'date-required': 'Se debe ingresar la fecha de entrada.',
            'no-currency-debit-and-credit-without-currency': 'La moneda debe ingresarse antes del crédito/débito de moneda extranjera.',
            'currency-debit-and-credit-required': 'Se debe ingresar una de las monedas de débito/crédito',
            'currency-debit-and-credit-one-of': 'La moneda de débito y crédito no se puede ingresar en el mismo asiento',
            'debit-with-currency-debit-relation': 'Especifique la moneda de débito para el deudor (entradas incompatibles)',
            'credit-with-currency-credit-relation': 'Especifique la moneda de crédito para el acreedor (entradas incompatibles)',
            'currency-required': 'Elija la moneda antes de agregar el precio',
            'currency-price-required': 'Se debe ingresar el precio de la moneda',

            'quantity-required': 'Se requiere cantidad',
            'price-required': 'Se requiere precio',
            'material-required': 'Se requiere artículo',
        },
    },

    menus: {
        ar: {
            'show-related-invoice': 'عرض الفاتورة المرتبطة',
            'show-related-journal': 'عرض اليومية المرتبطة',
        },
        en: {
            'show-related-invoice': 'Show related invoice',
            'show-related-journal': 'Show related journal',
        },
        es: {
            'show-related-invoice': 'Mostrar factura relacionada',
            'show-related-journal': 'Mostrar diario relacionado',
        }
    },
    
    messages: {
        ar: {
            'available-next-version': 'سيتم إتاحة الميزة في إصدار لاحق',
            'revolve-succeeded': 'خطوات التدوير تمت بنجاح، أعد تسجيل الدخول رجاءً',
            'adding-complated-successfully': 'تمت عملية الإضافة بنجاح',
            'editing-complated-successfully': 'تمت عملية التعديل بنجاح'
        },
        en: {
            'available-next-version': 'The feature will be available in a later version',
            'revolve-succeeded': 'Revolve steps are succeeded. please, login again',
            'adding-complated-successfully': 'adding operation completed successfully',
            'editing-complated-successfully': 'editing operation completed successfully'
        },
        es: {
            'available-next-version': 'La característica estará disponible en una versión posterior',
            'revolve-succeeded': 'Los pasos de revolución se realizan correctamente. por favor, inicie sesión nuevamente',
            'adding-complated-successfully': 'Agregar operación completada con éxito',
            'edit-complated-successfully': 'Operación de edición completada con éxito',
        }
    },

    'shown-rows-text': {
        ar: 'الأسطر المعروضة',
        en: 'shown rows',
        es: 'filas mostradas',
    },

    "posted-invoices": {
        ar: 'فواتير مرحلة',
        en: 'Posted invoices',
        es: ''
    },

    "unposted-invoices": {
        ar: 'فواتير غير مرحلة',
        en: 'Unposted invoices',
        es: ''
    },
    posted: {
        ar: 'مرحلة',
        en: 'Posted',
        es: ''
    },
    unposted: {
        ar: 'غير مرحلة',
        en: 'unposted',
        es: ''
    },
    "invoice-type": {
        "sale": {
            ar: 'بيع',
            en: 'Sale',
            es: ''
        },
        "buy": {
            ar: 'شراء',
            en: 'Buy',
            es: ''
        },
        "buyRefund": {
            ar: 'مرتجع شراء',
            en: 'BuyRefund',
            es: ''
        },
        "saleRefund": {
            ar: 'مرتجع بيع',
            en: 'SaleRefund',
            es: ''
        },

    },
    //saad's work
    "user permission": {
        ar: 'صلاحيات المستخدم',
        en: 'User Permission',
        es: 'Permiso de usuario'
    },
    "users permissions": {
        ar: 'صلاحيات المستخدمين',
        en: 'Users Permissions',
        es: 'permisos de usuarios'
    },
    'validation.required': {
        ar: 'هذا الحقل إجباري',
        en: 'This field is required',
        es: 'Este campo es obligatorio'
    },
    'financial-file': {
        ar: 'الملف المالي',
        en: 'Financial File',
        es: 'expediente financiero'
    }
}